import React, { useEffect, useState } from "react";

import { useMutation, useQueryClient } from "react-query";
import { Form, Select, Input } from "antd";
import Axios from "axios";
import { useDispatch, useSelector } from "react-redux";
//
import { SelectForm } from "../../common/Buttons";
import { setCountriesOptions } from "../../../redux/Actions/options_action";
import { FlopppyButton } from "../../common/ButtonWithLoading";
import {
  antdMessageError,
  antdMessageSuccess,
  phonenumberValid,
} from "../../../helpers/Utils";
import { useFetch } from "../../../hooks";
import ListSmsSendings from "../../table/ListSmsSendings";

function ModalSmsSending({
  data = [],
  phoneNumber,
  shipments,
  country_id,
  lost_cart_id,
}) {
  const { countries } = useSelector((state) => state.options);
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const utils = useQueryClient();

  const mutationSms = useMutation({
    mutationFn: (sms_sending) => {
      return Axios.post(`/api/v1/lost_carts/${lost_cart_id}/create_sms`, {
        sms_sending: {
          number: phoneNumber,
          body: sms_sending.body,
        },
      }).then((res) => res.data);
    },
    onSuccess: async () => {
      await utils.invalidateQueries(["lost_carts", { lost_cart_id }]);
      antdMessageSuccess();
      form.resetFields();
      setBodyTextID("");
    },
    onError: (error) => antdMessageError(error?.response?.data?.message),
  });

  const [bodyTextID, setBodyTextID] = useState(undefined);
  // hack
  const [_, setReloadForm] = useState(1);

  useEffect(() => {
    form.setFieldValue("country_id", country_id);
  }, [country_id]);

  useEffect(() => {
    dispatch(setCountriesOptions());
  }, []);

  const { value } = useFetch("/api/v1/sms_templates");

  const setSmsText = (evt, arg) => {
    let value = evt;
    if (value.search("[linkas i trakinima]") !== -1) {
      let courier_trackings = [];
      let courier_trackings_number = [];
      shipments.forEach((ship) => {
        ship.courier_trackings.forEach((track) => {
          courier_trackings.push(track.url);
          courier_trackings_number.push(track.number);
        });
      });
      if (courier_trackings.length === 1) {
        value = value.split("#[linkas i trakinima]").join(courier_trackings[0]);
        if (value.search("[siuntos numeris]")) {
          value = value
            .split("#[siuntos numeris]")
            .join(courier_trackings_number[0]);
        }
      } else if (courier_trackings.length > 1) {
        value = value
          .split("#[linkas i trakinima]")
          .join(courier_trackings.join(", "));
        if (value.search("[siuntos numeris]")) {
          value = value
            .split("#[siuntos numeris]")
            .join(courier_trackings_number.join(", "));
        }
      }
    }

    setBodyTextID(arg.children);
    form.setFieldsValue({ body: value });
  };
  return (
    <div className="col-12 bg-silver pt-2">
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={(values) => {
          mutationSms.mutate(values);
        }}
      >
        <Form.Item
          name="country_id"
          rules={[{ required: true, message: "Country is required" }]}
        >
          <Select
            options={countries}
            placeholder="Country"
            onClick={() => {
              setBodyTextID("");
              form.setFieldsValue({ body: "" });
              setReloadForm((prev) => prev + 1);
            }}
          />
        </Form.Item>
        <div className="ant-form-item">
          <SelectForm
            disabled={!form.getFieldValue("country_id")}
            onlyPlaceholder="Templates"
            options={value?.data
              ?.map((e) => ({
                value: e.body,
                label: e.message,
                country_id: e.country_id,
              }))
              ?.filter((e) => e.country_id == form.getFieldValue("country_id"))}
            onChange={(evt, arg) => setSmsText(evt, arg)}
            value={bodyTextID}
          />
        </div>
        <Form.Item
          name="body"
          rules={[{ required: true, message: "Body is required" }]}
        >
          <Input.TextArea
            autoSize={{ minRows: 2, maxRows: 6 }}
            placeholder="Body"
          />
        </Form.Item>
        {phonenumberValid(phoneNumber) && (
          <Form.Item className="text-right">
            <FlopppyButton htmlType="submit" loading={mutationSms.isLoading} />
          </Form.Item>
        )}
      </Form>
      <table className="table table-hover mt-3">
        <ListSmsSendings sms_sendings={data} />
      </table>
    </div>
  );
}

export default ModalSmsSending;
